__turbopack_context__.v({
  "content": "BlockMediaAccordionItem-module-scss-module__heBcnW__content",
  "copy": "BlockMediaAccordionItem-module-scss-module__heBcnW__copy",
  "fade-in": "BlockMediaAccordionItem-module-scss-module__heBcnW__fade-in",
  "headline": "BlockMediaAccordionItem-module-scss-module__heBcnW__headline",
  "headlineIcon": "BlockMediaAccordionItem-module-scss-module__heBcnW__headlineIcon",
  "headlineIconChevron": "BlockMediaAccordionItem-module-scss-module__heBcnW__headlineIconChevron",
  "isActive": "BlockMediaAccordionItem-module-scss-module__heBcnW__isActive",
  "isMounted": "BlockMediaAccordionItem-module-scss-module__heBcnW__isMounted",
  "root": "BlockMediaAccordionItem-module-scss-module__heBcnW__root",
  "summary": "BlockMediaAccordionItem-module-scss-module__heBcnW__summary",
});
